import React, { useEffect, useState } from 'react';

import { Alert, Box, Button, Spinner } from '@nimbus-ds/components';
import apiInstance from '../../utils/apiUtils';

const AppStatusBar: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [loadingActive, setLoadingActive] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = async () => {
    try {
      const result = await apiInstance.get(`/app/status`);
      const data = { ...(result.data as { is_active: boolean }) };

      setActive(data.is_active);
    } catch (error) {
      setActive(false);
    }
    setLoading(false);
  };

  const startStopApp = async () => {
    try {
      setLoadingActive(true);
      const result = await apiInstance.post(
        `/app/${active ? 'stop' : 'start'}`,
      );

      if (result.status === 201) {
        setActive(!active);
      }
    } catch (error) {
      console.log(error);
    }
    setLoadingActive(false);
  };

  if (loading) {
    return <></>;
  }

  return (
    <Box marginBottom="5">
      {active ? (
        <Alert appearance="success" title="Integração ativa">
          A integração está atualmente ativa em sua loja. Para desativar os
          recursos, basta clicar em &lsquo;Desativar recursos&lsquo;
          <Box display="flex" flexWrap="wrap" gap="2">
            <Button
              disabled={loadingActive}
              onClick={startStopApp}
              appearance="neutral"
            >
              {loadingActive ? (
                <>
                  <Spinner color="currentColor" size="small" /> Desativando
                </>
              ) : (
                <>Desativar recursos</>
              )}
            </Button>
          </Box>
        </Alert>
      ) : (
        <Alert appearance="danger" title="Aplicativo inativo">
          O aplicativo está instalado, mas não está ativo em sua loja. Para
          desfrutar de todos os recursos disponíveis, realize as configurações
          necessárias e clique em ativar.
          <Box display="flex" flexWrap="wrap" gap="2">
            <Button
              disabled={loadingActive}
              onClick={startStopApp}
              appearance="neutral"
            >
              {loadingActive ? (
                <>
                  <Spinner color="currentColor" size="small" /> Ativando
                </>
              ) : (
                <>Ativar todos recursos</>
              )}
            </Button>
          </Box>
        </Alert>
      )}
    </Box>
  );
};

export default AppStatusBar;
